//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

export default Object.freeze({
    address:                          'address',
    annualTaxableIncome:              'annualTaxableIncome',
    baseSettings:                     'baseSettings',
    calculationFields:                'calculationFields',
    city:                             'address.city',
    company:                          'company',
    email:                            'email',
    firstname:                        'firstname',
    hideReturnOnEquity:               'hideReturnOnEquity',
    houseNumber:                      'address.houseNumber',
    image:                            'image',
    importHash:                       'importHash',
    increaseInIncome:                 'increaseInIncome',
    increaseInIncomeInterval:         'increaseInIncomeInterval',
    increaseInOperatingCosts:         'increaseInOperatingCosts',
    increaseInOperatingCostsInterval: 'increaseInOperatingCostsInterval',
    increaseInValue:                  'increaseInValue',
    increaseInValueInterval:          'increaseInValueInterval',
    interest:                         'interest',
    lastname:                         'lastname',
    mobile:                           'mobile',
    newPassword:                      'newPassword',
    newPasswordRepeat:                'newPasswordRepeat',
    password:                         'password',
    passwordRepeat:                   'passwordRepeat',
    pdfSettings:                      'pdfSettings',
    phone:                            'phone',
    postalCode:                       'address.postalCode',
    redemption:                       'redemption',
    rentIncrease:                     'rentIncrease',
    rentIncreaseInterval:             'rentIncreaseInterval',
    street:                           'address.street',
    termsAccepted:                    'termsAccepted',
    website:                          'website',
});
